<template>
  <v-layout style="flex-direction:column">    
    <v-tabs class="mx-2 mt-2 sub-menu" style="flex:0 0 auto;"      
      slider-color="primary">                  
      <h2 class="pa-2">{{mission.MIS_LIBELLE}} : </h2>   
      <v-tab exact ripple :to="{name:'EditAdminMission'}">      
        Fiche Mission
      </v-tab>  
      <v-tab exact ripple :to="{name:'FormAdminMission'}">
        Infos générales
      </v-tab>      
      <v-tab ripple :to="{name:'DroitsAdminMission'}">
        Droits
      </v-tab>
      <!--v-tab ripple :to="{name:'MissionPlan'}">
        Planification
      </v-tab-->
    </v-tabs>    
    <router-view class="mt-0" />    
  </v-layout>
</template>

<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'


  @Component({
    name: 'AdminAdminMissionMenu'
  })
  export default class AdminAdminMissionMenu extends Vue {  
    get mission() {
      return this.$store.myGetters.originalAdmAdminMission
    }
  }
</script>

<style scope>

  .sub-menu .v-tabs__item--active{
    background-color:transparent;
  } 

</style>
